/**
 * Shared layout for /privacy-policy, /algemene-voorwaarden and /cookiebeleid.
 * Fetches admin-editable HTML from /api/legal/{slug} on mount. If admin hasn't
 * customized the content yet (empty html) we render the prop `defaultBody` so
 * the page is never blank.
 */
import { useEffect, useState } from "react";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";

export default function LegalPage({ slug, defaultTitle, defaultBody }) {
  const [title, setTitle] = useState(defaultTitle);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/legal/${slug}`);
        if (cancelled) return;
        if (data.title) setTitle(data.title);
        if (data.html && data.html.trim().length > 30) setHtml(data.html);
      } catch (e) {
        // Network error: fall through to default body
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return (
    <PublicLayout>
      <section className="oc-section">
        <div
          className="oc-container max-w-3xl prose prose-lg
            [&_h1]:font-display [&_h1]:font-bold [&_h1]:text-[40px] [&_h1]:text-oc-primary
            [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-[24px] [&_h2]:text-oc-primary [&_h2]:mt-10
            [&_h3]:font-display [&_h3]:font-semibold [&_h3]:text-[20px] [&_h3]:text-oc-primary [&_h3]:mt-8
            [&_p]:leading-[1.8] [&_p]:text-oc-textPrimary
            [&_a]:text-oc-secondary [&_a]:underline
            [&_ul]:list-disc [&_ul]:pl-6 [&_li]:my-1.5
            [&_ol]:list-decimal [&_ol]:pl-6"
        >
          <h1>{title}</h1>
          {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : defaultBody}
        </div>
      </section>
    </PublicLayout>
  );
}
